import React from 'react';

import { MembershipPopover } from '@silvertours/front-entities';
import { Button, Ui } from '@silvertours/front-shared';
import { useTranslations } from 'next-intl';
import {
  LockIcon,
  UserIcon,
  MembershipPanelWrapper,
} from './LoginButton.styles';
import { LoggedInActions } from '../LoggedInActions';
import { useLogin } from '../../../LoginForm';

type Props = {
  onClick?: () => void;
};

const LoginButton = ({ onClick }: Props) => {
  const { isLoggedIn, setShowLogin } = useLogin();
  const t = useTranslations('features.navigationLegacy.login');

  const handleLoginClick = () => {
    if (typeof onClick === 'function') {
      onClick();
    }
    setShowLogin(true);
  };

  const handleSignUpClick = () => {
    window.location.assign(t('signup.href'));
  };

  if (!isLoggedIn) {
    return (
      <Ui.Popover
        key="logged-out-actions"
        button={{
          as: Button,
          icon: <LockIcon />,
          variant: 'secondary',
          size: 'small',
          children: t('menu.button.loggedOut'),
          'data-testid': 'accountMenuButton',
        }}
      >
        <Ui.PopoverPanel>
          <Ui.PanelContentWrapper width="403px">
            <MembershipPanelWrapper>
              <MembershipPopover
                handleLoginClick={handleLoginClick}
                handleSignUpClick={handleSignUpClick}
              />
            </MembershipPanelWrapper>
          </Ui.PanelContentWrapper>
        </Ui.PopoverPanel>
      </Ui.Popover>
    );
  }

  return (
    <Ui.Popover
      key="logged-in-actions"
      button={{
        as: Button,
        icon: <UserIcon />,
        variant: 'secondary',
        size: 'small',
        children: t('menu.button.loggedIn'),
        'data-testid': 'accountMenuButton',
      }}
    >
      <Ui.PopoverPanel>
        <LoggedInActions />
      </Ui.PopoverPanel>
    </Ui.Popover>
  );
};

export { LoginButton };
